
import { defineComponent } from 'vue'
import { store } from "../shared/store.js"
import WardCard from "./WardCard.vue"
import ClinicCard from "./ClinicCard.vue"
import NursingTasks from '../patientDetail/NursingTasks.vue'

export default defineComponent({
  name: 'MainContent',
  components: {
    WardCard,
    ClinicCard,
    NursingTasks
  },
  data () {
    return {
      store,
      tab: null,
      locations: [
        {
          "bed": "01",
          "patient": {
            "name": "Strawberry Shortcake Jamz",
            "gender": "Female",
            "age": "32",
            "problemSummary": "Hypertension, Diabetes, Asthma"
          }
        },
        {
          "bed": "02",
          "patient": {
            "name": "Butter Cookie Jamz",
            "gender": "Male",
            "age": "35",
            "problemSummary": "Asthma, requires constant attention"
          }
        },
        {
          "bed": "03",
          "patient": null
        },
        {
          "bed": "04",
          "patient": {
            "name": "Pleach Blush",
            "gender": "Male",
            "age": "34",
            "problemSummary": "Amnesia, Vital signs inconsistent"
          }
        },
        {
          "bed": "05",
          "patient": null
        },
        {
          "bed": "06",
          "patient": null
        },
        {
          "bed": "07",
          "patient": null
        },
        {
          "bed": "08",
          "patient": null
        }
      ],
      newEncounter: false,
      searchPatient: false,
      selectedPatient: null,
      viewDetail: false
    }
  }
})
